// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as SlabDataVm from "./SlabDataVm.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CorePricingUtils from "../library/utils/CorePricingUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";

function getVm(campaign, vehicle_name, region_name) {
  switch (campaign.TAG | 0) {
    case /* Scheduled */0 :
        var campaign$1 = campaign.campaign;
        var time = campaign$1.approved_on;
        return {
                campaign_id: campaign$1.campaign_id,
                campaign_name: campaign$1.campaign_name,
                vehicle_name: vehicle_name,
                region_name: region_name,
                status: CorePricingUtils.isActiveCampaign(campaign$1.start_date) ? /* Active */0 : /* Scheduled */2,
                created_by: campaign$1.created_by,
                created_on: campaign$1.created_on,
                approved_by: Belt_Option.getWithDefault(campaign$1.approved_by, "N/A"),
                approved_on: time !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(time), "DD/MM/YYYY") : "N/A",
                start_date: campaign$1.start_date,
                end_date: campaign.end_date,
                base_fare: CurrencyMajorMinorMapper.baseToCurrency(campaign$1.fare_details.base_fare),
                free_duration: CorePricingUtils.fromMilliSecToMins(campaign$1.fare_details.free_duration),
                waiting_rate: CurrencyMajorMinorMapper.baseToCurrency(campaign$1.fare_details.waiting_rate_per_min),
                free_kms: campaign$1.fare_details.free_slab.free_kms,
                free_km_price_per_min: CurrencyMajorMinorMapper.baseToCurrency(campaign$1.fare_details.free_slab.price_per_min),
                slabs: SlabDataVm.getVm(campaign$1.fare_details.free_slab.free_kms, campaign$1.slabs)
              };
    case /* Pending */1 :
        var campaign$2 = campaign._0;
        return {
                campaign_id: campaign$2.campaign_id,
                campaign_name: campaign$2.campaign_name,
                vehicle_name: vehicle_name,
                region_name: region_name,
                status: /* Pending */1,
                created_by: campaign$2.created_by,
                created_on: campaign$2.created_on,
                approved_by: "N/A",
                approved_on: "N/A",
                start_date: campaign$2.start_date,
                end_date: undefined,
                base_fare: CurrencyMajorMinorMapper.baseToCurrency(campaign$2.fare_details.base_fare),
                free_duration: CorePricingUtils.fromMilliSecToMins(campaign$2.fare_details.free_duration),
                waiting_rate: CurrencyMajorMinorMapper.baseToCurrency(campaign$2.fare_details.waiting_rate_per_min),
                free_kms: campaign$2.fare_details.free_slab.free_kms,
                free_km_price_per_min: CurrencyMajorMinorMapper.baseToCurrency(campaign$2.fare_details.free_slab.price_per_min),
                slabs: SlabDataVm.getVm(campaign$2.fare_details.free_slab.free_kms, campaign$2.slabs)
              };
    case /* Rejected */2 :
    case /* Deleted */3 :
        return Curry._1(ErrorUtils$Catalyst.raiseError("CampaignDetailVm.re", "Invalid Campaign", undefined), undefined);
    
  }
}

export {
  getVm ,
  
}
/* CorePricingUtils Not a pure module */
